import { render } from "./ShippingAndReturns.vue?vue&type=template&id=3e128cfe"
import script from "./ShippingAndReturns.vue?vue&type=script&lang=js"
export * from "./ShippingAndReturns.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__